import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { ProductMasterDataContext } from '../../../../../context/ProductMasterDataContext';
import { ProductMasterDataFilter } from '../ProductMasterDataFilter';

interface ProductMasterDataFilterDropdownContentProps {
  filter: ProductMasterDataFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function ProductMasterDataFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: ProductMasterDataFilterDropdownContentProps) {
  const { productMasterData } = useContext(ProductMasterDataContext);

  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    const items = new Set<string>();
    for (const p of productMasterData.values()) {
      if (!filter.isSelectable(p)) continue;
      if (!filter.search(p, query)) continue;
      if (filterProps.company?.size && !filterProps.company.has(p.companyId)) continue;
      items.add(p.id);
    }
    return items;
  }, [filter, productMasterData, query]);

  const handleChange = (selected: Set<string>) => {
    filterProps.product = selected;
    if (!filterProps.product?.size) filterProps.product = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.product = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.product).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.product}
          values={values}
          onChange={handleChange}
          toText={id => productMasterData.get(id)?.productName}
          toSubText={id => productMasterData.get(id)?.productNumber}
        />
      </Grid>
    </Grid>
  );
}
